import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchTransectionListThunk } from 'slices/transectionSlice';

const TransactionDetailsPage = ({type,appId}) => {
    console.log("hello",type,appId)
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const transectionList = useSelector((state) => state.transection?.data?.data || []);

  const transaction = transectionList.find((t) => t._id === id);

  // Fetch data on mount if not available
  useEffect(() => {
    if (!transectionList.length) {
      if (type === "transactions-all") {
        dispatch(fetchTransectionListThunk({ type }));
      } else if (type === "transactions-app" && appId) {
        dispatch(fetchTransectionListThunk({ type, id: appId }));
      }
    }
  }, [dispatch, type, appId, transectionList.length]);
  if (!transaction) {
    return <div className="p-4 text-gray-700">Loading transaction details...</div>;
  }

  return (
    <div className="p-6">
      <button
        onClick={() => navigate(-1)}
        className="mb-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        ← Back
      </button>

      <div className="bg-white shadow-md rounded p-6 max-w-3xl mx-auto">
        <h2 className="text-xl font-semibold mb-4">Transaction Details</h2>

        <div className="grid grid-cols-2 gap-4 text-gray-800">
          <div><strong>Order ID:</strong> {transaction.order_id}</div>
          <div><strong>Transection ID:</strong> {transaction._id}</div>
          <div><strong>Amount:</strong> ₹{transaction.amount}</div>
          <div><strong>Mode:</strong> {transaction.mode}</div>
          <div><strong>Status:</strong> 
            <span className={`ml-2 px-2 py-1 rounded text-sm ${
              transaction.status === 'pending'
                ? 'bg-yellow-100 text-yellow-800'
                : transaction.status === 'success'
                ? 'bg-green-100 text-green-800'
                : 'bg-red-100 text-red-800'
            }`}>
              {transaction.status}
            </span>
          </div>
          <div><strong>User Name:</strong> {transaction.userId?.name}</div>
          <div><strong>User Id:</strong> {transaction.userId?._id}</div>
          <div><strong>User Email:</strong> {transaction.userId?.email}</div>
          <div><strong>App ID:</strong> {transaction.appId?.app_id}</div>
          <div><strong>Created At:</strong> {new Date(transaction.createdAt).toLocaleString()}</div>
          <div><strong>Updated At:</strong> {new Date(transaction.updatedAt).toLocaleString()}</div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailsPage;
